export const timeline = [
  {
    title: "Born in India",
    date: "2000",
    description:
      "Came into the world in India, where my journey of curiosity and creativity began.",
    className: "bg-gradient-to-r from-blue-400 to-purple-600",
  },
  {
    title: "Started Schooling",
    date: "2003",
    description:
      "Began my journey in formal education, discovering curiosity, creativity, and the joy of learning new things.",
    className: "bg-gradient-to-r from-pink-500 to-orange-400",
  },
  {
    title: "Started University",
    date: "2018",
    description:
      "Began my university life, diving deep into technology, logic, and innovation.",
    className: "bg-gradient-to-r from-emerald-400 to-cyan-600",
  },
  {
    title: "Started Freelancing",
    date: "2020",
    description:
      "Stepped into the real tech world, helping clients build products while learning independently.",
    className: "bg-gradient-to-r from-fuchsia-400 to-purple-600",
  },
  {
    title: "Started Working in Vodafone Qatar (via Wipro)",
    date: "2022",
    description:
      "Joined Vodafone Qatar through Wipro, where I worked on enterprise-level applications and teamwork.",
    className: "bg-gradient-to-r from-rose-400 to-red-600",
  },
  {
    title: "Moved to Dubai",
    date: "2024",
    description:
      "Relocated to Dubai, embracing new opportunities and challenges in a multicultural tech environment.",
    className: "bg-gradient-to-r from-amber-300 to-yellow-600",
  },
  {
    title: "Started Working in 9x Technology LLC",
    date: "2024",
    description:
      "Joined 9x Technology as a Full Stack Developer, building scalable and modern web solutions.",
    className: "bg-gradient-to-r from-slate-600 to-zinc-800",
    isCurrent: true,
  },
  {
    title: "Traveling the World",
    date: "Future",
    description:
      "Exploring different countries, cultures, and cuisines, collecting memories beyond borders.",
    className: "bg-gradient-to-r from-teal-400 to-lime-500",
  },
  {
    title: "Explore Machu Picchu & The Sacred Valley, Peru",
    date: "Future",
    description:
      "Hike through the ancient Inca Trail, explore Machu Picchu at sunrise, and feel the spirit of a lost civilization surrounded by misty mountains and timeless beauty.",
    className: "bg-gradient-to-r from-indigo-400 to-violet-600",
  },
  {
    title: "Trek to Everest Base Camp, Nepal",
    date: "Future",
    description:
      "Challenge myself with a 12-day journey through the Himalayas to stand beneath the world's highest peak — a mix of endurance, humility, and breathtaking wonder.",
    className: "bg-gradient-to-r from-sky-400 to-indigo-500",
  },
  {
    title: "Road Trip Across Europe",
    date: "Future",
    description:
      "Drive through Italy, Switzerland, France, and Germany, chasing sunsets, exploring art, and tasting freedom on every highway.",
    className: "bg-gradient-to-r from-green-400 to-teal-500",
  },
  {
    title: "Experience Northern Lights in Iceland",
    date: "Future",
    description:
      "Witness the magical Aurora Borealis dance across the Arctic sky — a dreamlike experience of nature's wonder.",
    className: "bg-gradient-to-r from-orange-400 to-amber-700",
  },
  {
    title: "Grow My YouTube Channel",
    date: "Future",
    description:
      "Build an inspiring online community by sharing my gaming, tech, and life experiences — connecting with people worldwide.",
    className: "bg-gradient-to-r from-rose-500 via-fuchsia-500 to-purple-600",
  },
];
